import { Pipe, PipeTransform } from '@angular/core';
import { LegalDateTimeService } from '../services/legal-datetime.service';

@Pipe({
  name: 'auditDateAgo',
  pure: true
})
export class AuditDateAgoPipe implements PipeTransform {
  constructor(private legalDate: LegalDateTimeService) {}

  transform(value: string | number | Date | null | undefined): string {
    return this.legalDate.auditAgo(value);
  }
}
